import {CLEAR_ATTACHMENTS} from "../../../enums/Request/request.types";

export const clearAttachmentsAction = () => {
    return {
        type: CLEAR_ATTACHMENTS,
    };
};
